module.exports = __webpack_public_path__ + "static/img/muusa_small.29aa10e.png";